import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';

import { Observable } from 'rxjs';


@Injectable()
export class PartsBulletinsService {

  private endpointURL = 'parts-bulletin/all';
  private endpointURL_newBulletins = 'parts-bulletin/new';

  private serviceBulletinFilter: string;

  private allParts;

  constructor(private http: HttpClient) { }

  /** GET Bulletin from the server */

  getAllPartsBulletins(): Observable<any> {
    return this.http.get(this.endpointURL,{withCredentials : true});
  }

  getNewPartsBulletins(): Observable<any> {
    return this.http.get(this.endpointURL_newBulletins,{withCredentials : true});
  }

  // get user's history of Parts Bulletins

  getHistoryPartsBulletins(userId): Observable<any> {
    return this.http.get(`user-info/qID/${userId}/pbsHistorylist`,{withCredentials : true});
  }

  getUserSavedPartsBulletins(userId): Observable<any> {
    return this.http.get(`user-info/qID/${userId}/pbs/userSavedBulletinGroupCategory`,{withCredentials : true});
  }

  // add user visited bulletin to his history
  addBulletinToUserHistory(userId, id) {
    return this.http.post(`user-info/qID/${userId}/addPBSToHistorylist/${id}`, '',{withCredentials : true});
  }
 

  saveFilterData(filter: string) {
    this.serviceBulletinFilter = filter;
  }

  getFilterData(): string {
    return this.serviceBulletinFilter;
  }

}
